import {
  Box,
  Button,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ErrorModal from "../../../utils/ErrorModal";

const AddPlant = () => {

  const [plant, setPlant] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const { plantId } = useParams();

  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = JSON.parse(localStorage.getItem("org"));

  const handleChange = (e) => {
    setPlant({ ...plant, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = plant || {};

    const isEmpty = (value) => !value || value.trim() === "";

    if (isEmpty(data.name)) newErrors.name = "Plant Name is required";
    if (isEmpty(data.gst)) newErrors.gst = "GST Number is required";
    if (isEmpty(data.address)) newErrors.address = "Address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {

    if (!validateForm()) return;

    setLoading(true);

    try {

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/plant`,
        {
          orgId: orgId,
          username: user.username,
          name: plant.name,
          gst: plant.gst,
          address: plant.address,
        },
        {
          headers: { Authorization: `Bearer ${user.accessToken}` },
        }
      );

      navigate("/approval/admin/plants");

    } catch (error) {

      setOpenError(true);
      setErrorMsg(
        error.response?.data?.Exception || "Something went wrong. Please try again"
      );

    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {

    if (!validateForm()) return;

    setLoading(true);

    try {

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/plant?plantId=${plantId}`,
        {
          username: user.username,
          name: plant.name,
          gst: plant.gst,
          address: plant.address,
        },
        {
          headers: { Authorization: `Bearer ${user.accessToken}` },
        }
      );

      navigate("/approval/admin/plants");

    } catch (error) {

      setOpenError(true);
      setErrorMsg(
        error.response?.data?.Exception || "Something went wrong. Please try again"
      );

    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/approval/admin/plants");
  };

  return (
    <div style={{ position: "relative" }}>

      {loading && <div className="loading-div"></div>}

      <div className="dashboard-container">

        <Typography variant="h4">Enter Plant Details</Typography>

        <Grid2
          container
          columnSpacing={2}
          sx={{ width: "60%", margin: "auto" }}
          py={5}
        >

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="name">Plant Name</label>
            <input
              type="text"
              id="name"
              name="name"
              onChange={handleChange}
              value={plant?.name || ""}
              className={`${errors.name && "input-error"}`}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <label htmlFor="gst">GST Number</label>
            <input
              type="text"
              id="gst"
              name="gst"
              onChange={handleChange}
              value={plant?.gst || ""}
              className={`${errors.gst && "input-error"}`}
            />
            {errors.gst && <p className="error">{errors.gst}</p>}
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              rows="3"
              onChange={handleChange}
              value={plant?.address || ""}
              className={`${errors.address && "input-error"}`}
            />
            {errors.address && <p className="error">{errors.address}</p>}
          </Grid2>

        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>

        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>

        {plant && plant.plantId ? (
          <Button className="btn-contained" onClick={handleUpdate}>
            Update Plant
          </Button>
        ) : (
          <Button className="btn-contained" onClick={handleSubmit}>
            Create Plant
          </Button>
        )}

      </Box>

      <ErrorModal
        open={openError}
        handleClose={() => setOpenError(false)}
        msg={errorMsg}
      />

    </div>
  );
};

export default AddPlant;